const SUGGESTIONS = Object.freeze({
  dashboard: ["¿Qué debería revisar hoy?", "¿Hay algún desvío energético relevante?"],
  consumption: [
    "¿Cómo fue el consumo en este período?",
    "Comparalo con el período anterior",
    "¿Qué pasó con el consumo nocturno?",
  ],
  demand: ["¿Tuvimos picos de demanda?", "¿Cómo estamos frente a la potencia contratada?"],
  reactive: ["¿Cómo estuvo la energía reactiva?", "¿Hay riesgo de penalización por reactiva?"],
  billing: ["¿Hubo penalizaciones en las facturas?", "¿Qué costos se destacan en este período?"],
  tariff: ["¿Qué contexto tarifario aplica?", "¿Dónde están las principales oportunidades de costo?"],
  recommendations: ["¿Qué recomendación debería priorizar?", "¿Qué impacto energético tienen estas mejoras?"],
  projects: ["¿Cómo priorizar estos proyectos?", "¿Qué proyecto tendría mayor impacto energético?"],
  ai_reports: ["Ayudame a interpretar esta información", "¿Qué hallazgos energéticos son más relevantes?"],
  other: ["¿Cómo está nuestro desempeño energético?", "¿Qué oportunidad debería analizar primero?"],
});

export const getContextualSuggestions = (section) => SUGGESTIONS[section] || SUGGESTIONS.other;

